(() => {
  const STORAGE_KEY = 'mlab-audio-enabled';
  const POSITION_KEY = 'mlab-hero-audio-position';
  const VOLUME = 0.16;
  const audio = document.getElementById('MlabBackgroundAudio');
  const buttons = [...document.querySelectorAll('[data-mlab-audio-toggle]')];
  let wantsAudio = localStorage.getItem(STORAGE_KEY) !== 'false';
  let unlockArmed = false;

  if (!audio || buttons.length === 0) return;

  audio.volume = VOLUME;

  const savePlaybackPosition = () => {
    if (!Number.isFinite(audio.currentTime)) return;
    sessionStorage.setItem(
      POSITION_KEY,
      JSON.stringify({
        position: audio.currentTime,
        savedAt: Date.now(),
        playing: !audio.paused,
      })
    );
  };

  const restoredPosition = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(POSITION_KEY));
      if (!saved || !Number.isFinite(saved.position)) return 0;
      const elapsed = saved.playing && Number.isFinite(saved.savedAt) ? Math.max(0, (Date.now() - saved.savedAt) / 1000) : 0;
      const position = saved.position + elapsed;
      return Number.isFinite(audio.duration) && audio.duration > 0 ? position % audio.duration : position;
    } catch (_error) {
      return 0;
    }
  };

  const setButtonState = (playing) => {
    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? 'Pause background music' : 'Play background music');
      button.title = playing ? 'Pause music' : 'Play music';
    });
  };

  const play = async () => {
    try {
      await audio.play();
      wantsAudio = true;
      localStorage.setItem(STORAGE_KEY, 'true');
      setButtonState(true);
      disarmPlaybackUnlock();
    } catch (_error) {
      setButtonState(false);
      if (wantsAudio) armPlaybackUnlock();
    }
  };

  const pause = (remember = true) => {
    audio.pause();
    if (remember) {
      wantsAudio = false;
      localStorage.setItem(STORAGE_KEY, 'false');
      disarmPlaybackUnlock();
    }
    savePlaybackPosition();
    setButtonState(false);
  };

  const restoreAndPlay = () => {
    const resume = () => {
      const position = restoredPosition();
      if (position > 0) audio.currentTime = position;
      play();
    };

    if (audio.readyState >= 1) {
      resume();
    } else {
      audio.addEventListener('loadedmetadata', resume, { once: true });
      audio.load();
    }
  };

  const unlockPlayback = () => {
    if (wantsAudio && audio.paused) play();
  };

  function armPlaybackUnlock() {
    if (unlockArmed) return;
    unlockArmed = true;
    document.addEventListener('pointerdown', unlockPlayback, { once: true, passive: true });
    document.addEventListener('keydown', unlockPlayback, { once: true });
  }

  function disarmPlaybackUnlock() {
    if (!unlockArmed) return;
    unlockArmed = false;
    document.removeEventListener('pointerdown', unlockPlayback);
    document.removeEventListener('keydown', unlockPlayback);
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      if (audio.paused) {
        play();
      } else {
        pause();
      }
    });
  });

  let lastPositionSave = 0;
  audio.addEventListener('timeupdate', () => {
    const now = Date.now();
    if (now - lastPositionSave < 750) return;
    lastPositionSave = now;
    savePlaybackPosition();
  });

  window.addEventListener('pagehide', savePlaybackPosition);

  let resumeAfterVisibility = false;
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      resumeAfterVisibility = !audio.paused;
      if (resumeAfterVisibility) {
        savePlaybackPosition();
        audio.pause();
        setButtonState(false);
      }
    } else if (resumeAfterVisibility && wantsAudio) {
      resumeAfterVisibility = false;
      play();
    }
  });

  setButtonState(false);
  if (wantsAudio) restoreAndPlay();
})();
